"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FilterKeyword;
var _react = _interopRequireDefault(require("react"));
var _textInput = _interopRequireDefault(require("@ux/text-input"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _react2 = require("@linaria/react");
const FilterKeywordContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FilterKeywordContainer",
  class: "pl-f1af9abs"
});
function FilterKeyword({
  keywordPlaceholder,
  keyword,
  handleSearch
}) {
  return /*#__PURE__*/_react.default.createElement(FilterKeywordContainer, {
    "data-cy": "filter-keyword"
  }, /*#__PURE__*/_react.default.createElement(_textInput.default, {
    id: "filter-keyword-input",
    "data-cy": "filter-keyword-input",
    label: keywordPlaceholder,
    placeholder: keywordPlaceholder,
    value: keyword,
    onChange: handleSearch,
    visualSize: "md"
  }));
}
FilterKeyword.propTypes = {
  keywordPlaceholder: _propTypes.default.string,
  keyword: _propTypes.default.string,
  handleSearch: _propTypes.default.func
};